export function isEnabled(obj, key) {

    if (key?.includes("Sub")) {
        key = key.replace("Sub", "")
    }

    try {
        if (key === 'p081') {
            return true;
        }
        var ok = obj.checkItemStatus[parseInt(key.substring(1))] === "1";
        return ok;
    } catch (e) {
        return false;
    }
};


export const 未做 = "未做";